export const staticMenuItems = {
    home: {
        name: 'Home',
        path: '/',
        icon: 'mdi-home',
    },
    products: {
        name: 'Products',
        icon: "mdi-cube",
        items: [
            { name: 'LoopCAD', description: '', path: '/product/loopcad' },
            { name: 'HeatCAD', description: '', path: '/product/heatcad', },
            { name: 'PlumbingCAD', description: '', path: '/product/plumbingcad', },
            { name: 'LengthWise', description: '', path: '/product/lengthwise', },
            { name: 'Custom Software', description: '', path: '/product/custom', },
            { name: 'All Products', description: '', path: '/', },
        ],
        mainClickPath: "/",
    },
    store: {
        name: 'Pricing',
        path: '/store',
        icon: 'mdi-store',
    },
    activation: {
        name: 'Activation',
        icon: 'mdi-key-variant',
        items: [
            { name: 'LoopCAD', description: '', path: '/activation/loopcad', },
            { name: 'HeatCAD', description: '', path: '/activation/heatcad', },
            { name: 'PlumbingCAD', description: '', path: '/activation/plumbingcad', },
        ],
        mainClickPath: "/activation/loopcad",
    },
    support: {
        name: 'Support',
        icon: "mdi-face-agent",
        items: [
            { name: 'FAQs', description: '', path: '/support/faqs', },
            { name: 'Tutorials', description: '', path: '/support/tutorial', },
            { name: 'Webinars', description: '', path: '/support/webinars', },
            { name: 'Revision History', description: '', path: '/support/revisionhistory', },
            { name: 'Submit Help Ticket', description: '', path: '/support/ticket', },
        ],
        mainClickPath: "/support/supporthome",
    },
    downloads: {
        name: 'Downloads',
        icon: "mdi-file-download",
        items: [
            { name: 'LoopCAD', description: '', path: '/download/loopcad', },
            { name: 'HeatCAD', description: '', path: '/download/heatcad', },
            { name: 'PlumbingCAD', description: '', path: '/download/plumbingcad', },
            { name: 'LengthWise', description: '', path: '/download/lengthwise', },
        ],
        mainClickPath: "/download/loopcad",
    },
}

export const mobileMenuItems = {
    contact: {
        name: 'Contact Us',
        path: '/contact',
        icon: 'mdi-phone-message',
    },
    company: {
        name: 'Our Company',
        icon: "mdi-domain",
        items: [
            { name: 'About Us', description: '', path: '/about', },
            { name: 'Latest News', description: '', path: '/news', },
        ],
    },
}

export const dynamicMenuItems = {
    cart: {
        name: 'My Cart',
        path: '/store/cart',
        icon: 'mdi-cart',
    },
    myAccount: {
        name: 'My Account',
        path: '/myaccount/account',
        icon: 'mdi-account',
    },
}
